import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </SmoothScroll>
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
